import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../App";
import GoldChart from "./GoldChart";
import Reveal from "./Reveal";
import { useLang } from "../i18n/i18n";

const IMG =
  "https://images.unsplash.com/photo-1762463176319-8416bf1e6a8e?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600";

export default function Evolution() {
  const { t } = useLang();
  const [points, setPoints] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/gold-history`)
      .then((r) => setPoints(r.data.points || []))
      .catch(() => {});
  }, []);

  return (
    <section className="relative py-28 overflow-hidden" data-testid="evolution-section">
      <div className="absolute inset-0">
        <img src={IMG} alt="" className="w-full h-full object-cover opacity-15" />
        <div className="absolute inset-0 bg-gradient-to-b from-ink via-ink/70 to-ink" />
      </div>

      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid gap-14 lg:grid-cols-2 items-center">
          <Reveal>
            <p className="text-xs tracking-[0.35em] uppercase text-gold">{t("evo.eyebrow")}</p>
            <p className="mt-6 font-display text-[26vw] sm:text-[11rem] leading-none gold-text tabular" data-testid="evolution-multiplier">
              ×10
            </p>
            <p className="mt-2 text-2xl sm:text-3xl text-goldlight font-display" data-testid="evolution-increase">
              +1009 %
            </p>
          </Reveal>

          <Reveal delay={0.12}>
            <div className="space-y-8">
              <div className="flex items-baseline justify-between border-b border-gold/15 pb-5">
                <span className="font-display text-2xl text-cream/80">2005</span>
                <span className="font-display text-3xl sm:text-4xl text-cream tabular" data-testid="evolution-2005">
                  539 $ <span className="text-lg text-mutedc">{t("evo.ounce")}</span>
                </span>
              </div>
              <div className="flex items-baseline justify-between border-b border-gold/15 pb-5">
                <span className="font-display text-2xl text-cream/80">2026</span>
                <span className="font-display text-3xl sm:text-4xl text-goldlight tabular" data-testid="evolution-2026">
                  5 979 $ <span className="text-lg text-mutedc">{t("evo.ounce")}</span>
                </span>
              </div>
              <p className="text-base sm:text-lg leading-relaxed text-cream/70 max-w-md">{t("evo.caption")}</p>
            </div>
          </Reveal>
        </div>

        {points.length > 1 && (
          <Reveal delay={0.1}>
            <div className="mt-16">
              <div className="mb-6 flex items-center justify-between flex-wrap gap-2">
                <p className="text-xs tracking-[0.3em] uppercase text-gold/80">{t("evo.chartTitle")}</p>
                <p className="text-xs text-mutedc">{t("evo.chartSub")}</p>
              </div>
              <GoldChart points={points} />
            </div>
          </Reveal>
        )}
      </div>
    </section>
  );
}
